<script setup lang="ts">
defineProps<{ q: string }>()
</script>

<template>
  <details class="group">
    <summary class="cursor-pointer list-none p-6 hover:bg-slate-50 transition-colors duration-200 rounded-lg">
      <div class="flex items-center justify-between">
        <span class="text-lg font-semibold text-slate-900 group-open:text-primary-main transition-colors duration-200">
          {{ q }}
        </span>
        <div class="flex h-8 w-8 items-center justify-center rounded-full bg-slate-100 group-open:bg-primary-main/10 transition-all duration-200">
          <svg class="h-5 w-5 text-slate-600 group-open:text-primary-main transform transition-transform duration-200 group-open:rotate-180" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>
    </summary>
    
    <div class="px-6 pb-6">
      <div class="pt-4 text-slate-600 leading-relaxed text-base border-t border-slate-100">
        <slot />
      </div>
    </div>
  </details>
</template>
